import { createAsyncThunk } from "@reduxjs/toolkit";

import { SubscriptionDetails } from "../types/subscription";

import { ThunkConfig } from "@/app/providers/StoreProvider";
import { ApiError } from "@/shared/types";
import { handleError } from "@/shared/lib/helpers/utils";

export const fetchDetails = createAsyncThunk<SubscriptionDetails, void, ThunkConfig<ApiError>>(
  "subscription/fetchDetails",
  async (_, thunkApi) => {
    const { extra, rejectWithValue } = thunkApi;

    try {
      const response = await extra.api.get<SubscriptionDetails>("/api/billing/new_subscription_info");

      return response.data;
    } catch (err) {
      return rejectWithValue(handleError(err));
    }
  }
);
